import { render, staticRenderFns } from "./Figure.vue?vue&type=template&id=1f73bb57&scoped=true&lang=pug"
import script from "./Figure.vue?vue&type=script&lang=js"
export * from "./Figure.vue?vue&type=script&lang=js"
import style0 from "./Figure.styl?vue&type=style&index=0&id=1f73bb57&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f73bb57",
  null
  
)

export default component.exports